import Vue from 'vue/dist/vue.esm'
import ContactUs from '../components/ContactUs'
import VeeValidate from 'vee-validate';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import babelPolyfill from 'babel-polyfill'

Vue.use(VueReCaptcha, { siteKey: '6Lc9kVodAAAAALqWDP8fNs0VVKZyhlzTDeq7dLWC' })
Vue.use(VeeValidate, {
    fieldsBagName: 'inputs',
    initial: false
});

document.addEventListener('DOMContentLoaded', () => {
    new Vue({
        el: '#contact_us_form',
        components: {
            ContactUs
        },
    })
})